import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import axios from 'axios'
Vue.config.productionTip = false
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
Vue.prototype.$axios = axios;
window.axios = axios;         
require("@/assets/styles/styles.css");
new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
